<div class="fa-stack fa-fw timezone">
  <i class="fas fa-fw fa-globe-americas fa-stack-1x"></i>
  <i class="far fa-fw fa-clock fa-stack bg-white"></i>
</div>
